import { mdfesStatus } from '@/utils/options';

export default {
  beforeList: ({ form }) => {
    form.mdfes.forEach((mdfe) => {
      mdfe.destroyDisabled = false;
      mdfe.disableItemMoreActions = {
        openConfirmationModal: mdfe.status === 'authorized',
        // printDanfe: productInvoice.status !== productInvoiceStatus.AUTHORIZED,
        // changeNumberNFe: productInvoice.status !== productInvoiceStatus.PENDING && productInvoice.status !== productInvoiceStatus.REJECTED,
        // cancelNFe: productInvoice.status !== productInvoiceStatus.AUTHORIZED,
        // correctionLetters: productInvoice.status !== productInvoiceStatus.AUTHORIZED,
        // events: productInvoice.status === productInvoiceStatus.PENDING,
        // downloadXml: productInvoice.status === productInvoiceStatus.PENDING,
      };
    });
  },
};
